<template>
  <div>
    <Navigation />

  <div class="grid__section">
    <section class="section__container top__container blog__details">
       <h1 class="title center__text">ENVOI SMS GRANDE DISTRIBUTION / COMMERCE <br/>DE DÉTAIL</h1>
                     <img class="card__image" src="/../images/boutique.png" alt="" />

      <h2>
        Quelles stratégies pouvez-vous mettre en place pour susciter de l'enthousiasme autour de votre activité commerciale ?
      </h2>
      <p>
        Il existe de nombreux thèmes et occasions pour communiquer avec votre clientèle et créer de l'engouement autour de votre 
        activité commerciale. Le taux d'ouverture des SMS PRO par les clients dépasse largement celui des autres médias marketing 
        tels que le démarchage téléphonique, le mailing ou le marketing direct papier.
      </p>
      <p>
        Vos clients apprécient de recevoir des messages personnalisés contenant des informations pertinentes vous concernant.
         De plus en plus de commerçants adoptent une stratégie de fidélisation via SMS en envoyant à tous leurs contacts des 
         invitations pour :
      </p>
      
        <li>Des dégustations<br/></li>
        <li>Des ventes privées<br/></li>
        <li>Des nouvelles techniques de soin <br/></li>
        <li>Des notifications de livraison ou de retrait en magasin</li>
    
      <p>
        Ils mettent également en place des campagnes SMS de manière stratégique en utilisant les fonctionnalités d'envois 
        différés et autres outils disponibles.
      </p>
      <p>
        Enfin, en complément de vos envois programmés, il est important de constituer une base de contacts précise qui vous
         permettra d'optimiser l'utilisation des SMS personnalisés. Vos clients recevront ainsi un SMS mentionnant leur prénom, 
         leur titre tel que "Madame", "Monsieur" ou même "Cher Aly", ce qui renforcera la proximité, le lien et la considération 
         que vous leur témoignez.
      </p>
      <h2>Exemples de campagnes SMS :</h2>

      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/com-boutique-1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/com-boutique-2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/com-boutique-3.png" />
        </div>
      </div>
    </section>
     <SideNav/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from './SideNav';
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
